import { Result } from 'srs-middleware';

export class EmptyResultError {
	/**
	 *
	 */

	message: string;
	name: string;

	constructor() {
		//super('No data available in result object');
		this.message = 'No data available in result object';
		this.name = 'EmptyResultError';
	}
}

/**
 * Wraps an endpoint function so that an EmptyResultError will
 * be thrown if the function is called on an empty result.
 * Without this decorator, endpoints throw Internal Server Errors
 * when called with empty results, which isn't as informative and
 * thus can't be dealt with as easily.
 * @note When serberus 2.0 comes out this functionality
 * should me moved to srs-middleware
 * @param originalFunction the function to wrap
 * @returns a function that checks to make sure the passed result
 *          is not empty before handing if off to originalFunction.
 *          If it is empty, an EmptyResultError will be thrown
 */
export function throwEmptyResult(originalFunction): typeof originalFunction {
	return function (result: Result): Promise<Result> {
		if (result?.resultId === 0) {
			// If result is empty
			throw new EmptyResultError();
		}
		const newResult = originalFunction.apply(this, arguments);
		if (newResult.resultID === 0) {
			// if the newResult is empty
			throw new EmptyResultError();
		}
		return newResult;
	};
}

/**
 *
 * @param originalFunction
 * @returns the same function but when result.resultId is 0 it will
 * return {data:null,loading:false,error:EmptyResultError}.
 */
export function returnEmptyResultError(originalFunction): typeof originalFunction {
	return function (result: Result) {
		// Call the function no matter what so that React hooks don't break
		const originalReturn = originalFunction.apply(this, arguments);
		if (result?.resultId === 0) {
			// If result is empty
			return {
				data: null,
				loading: false,
				error: new EmptyResultError(),
			};
		}
		return originalReturn;
	};
}
